import PropTypes from "prop-types";
import React from "react";
import Appointment from "../../../assets/assets/noun_Empty_2900960.svg";
import monthName from "./monthName";

const Slots = (props) => {
  const { state, migrationDays, migrationSlots, btnValue, found } = props;

  const processText = (inputText) => {
    let textArray = inputText.split("-");
    const output = textArray.map((item) => item.trim());
    return {
      startTime: output[0],
      endTime: output[1],
    };
  };

  return (
    <div>
      {migrationDays &&
      migrationDays.length !== 0 &&
      migrationSlots &&
      migrationSlots.length > 0 &&
      found === true ? (
        <>
          <h3 className="available-times">
            Please select available appointment times (WAT) on
            <span>
              {" "}
              {monthName(state.month)} {state.date},
            </span>{" "}
            {state.year}
          </h3>
          <div className="demo-time">
            {migrationSlots &&
              migrationSlots.map((slot, index) => (
                <button
                  onClick={() =>
                    btnValue(
                      index,
                      processText(slot.time).startTime,
                      processText(slot.time).endTime,
                      slot.desc
                    )
                  }
                  key={slot.desc}
                  className={
                    state.active && index === state.index
                      ? "time-available2"
                      : "time-available"
                  }
                >
                  {(processText(slot.time).startTime)}
                  {" "}-{" "}
                  {(processText(slot.time).endTime)}
                </button>
              ))}
          </div>
        </>
      ) : (
        <div className="no-appointments">
          <img src={Appointment} alt="icon" />
          {migrationDays &&
          migrationDays.length > 0 &&
          migrationSlots &&
          migrationSlots.length === 0 &&
          state.date !== "" ? (
            <>
              <h3>
                {found === true
                  ? "All The Time Slots For This Day Has Been taken"
                  : "Please Select A Day"}
              </h3>
              <p>Please make another selection to see available time slots</p>
            </>
          ) : (
            <>
              <h3>No Appointments Yet</h3>
              <p>Please Select Year, Month, Day to see available time slots</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

Slots.propTypes = {
  btnValue: PropTypes.func,
  found: PropTypes.bool,
  migrationDays: PropTypes.shape({
    length: PropTypes.number,
  }),
  migrationSlots: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }),
  state: PropTypes.shape({
    active: PropTypes.any,
    date: PropTypes.string,
    index: PropTypes.any,
    month: PropTypes.any,
    year: PropTypes.any,
  }),
};

export default Slots;
